import { Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

function NoContent({ sx, title, p = 10 }) {
  const { t } = useTranslation(['messages']);

  return (
    <Typography
      sx={{
        ...sx,
        p,
        textAlign: 'center',
        width: '100%',
      }}
    >
      {title || t('no_content', { ns: 'messages' })}
    </Typography>
  );
}

export default NoContent;
